module.exports = __webpack_public_path__ + "static/media/sampleoptions.65339041.xlsx";